module.exports = __webpack_public_path__ + "img/denmark-tuberculosis-female.42951be8.png";